import CookieMgr from './CookieMgr';

/**
 * 通用工具类
 * 提供环境检测和日志开关控制
 */
export default class Util {
  /**
   * 是否为开发环境
   */
  static isDev = process.env.NODE_ENV === 'development';

  /**
   * 日志开关控制
   * @returns 是否开启日志
   * 
   * 规则:
   * - 开发环境: 始终开启日志
   * - 生产环境: 通过 Cookie 'isLog' 控制 (值为 '1' 时开启)
   */
  static get isLog(): boolean {
    // 开发环境: 始终开启日志
    if (this.isDev) return true;

    // 生产环境: 通过 Cookie 控制
    const log = CookieMgr.getCookie('isLog');
    return log === '1';
  }

  /**
   * SDK 日志控制 (可选)
   * @returns 是否开启 SDK 日志
   */
  static get isSdkLog(): boolean {
    const log = CookieMgr.getCookie('isSdkLog');
    return log === '1';
  }

  /**
   * 测试模式控制 (可选)
   * @returns 是否为测试模式
   */
  static get isTestMode(): boolean {
    if (this.isDev) return true;
    const log = CookieMgr.getCookie('isTestMode');
    return log === '1';
  }
}
